import { memo } from 'react'

import Section3 from './Section3'

const Section3Component = memo(Section3)

export default Section3Component
